import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit , DestroyRef} from '@angular/core';
import { IsActiveMatchOptions } from '@angular/router';
import { takeUntil } from 'rxjs';
import { FuseVerticalNavigationComponent } from 'fuseui';
import { FuseNavigationService } from 'fuseui';
import { FuseNavigationItem } from 'fuseui';
import { FuseUtilsService } from 'fuseui';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'fuse-vertical-navigation-basic-item',
    templateUrl: './basic.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class FuseVerticalNavigationBasicItemComponent implements OnInit, OnDestroy
{
    // @ts-ignore
    @Input() item: FuseNavigationItem;
    // @ts-ignore
    @Input() name: string;

    isActiveMatchOptions: IsActiveMatchOptions;
    // @ts-ignore
    private _fuseVerticalNavigationComponent: FuseVerticalNavigationComponent;

    /**
     * Constructor
     */
    constructor(private _changeDetectorRef: ChangeDetectorRef,
        private _fuseNavigationService: FuseNavigationService,
        private _fuseUtilsService: FuseUtilsService, private readonly destroyRef: DestroyRef)
    {
        // Set the equivalent of {exact: false} as default for active match options.
        // We are not assigning the item.isActiveMatchOptions directly to the
        // [routerLinkActiveOptions] because if it's "undefined" initially, the router
        // will throw an error and stop working.
        this.isActiveMatchOptions = this._fuseUtilsService.subsetMatchOptions;
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {
        // Set the "isActiveMatchOptions" either from item's
        // "isActiveMatchOptions" or the equivalent form of
        // item's "exactMatch" option
        this.isActiveMatchOptions =
            this.item.isActiveMatchOptions ?? this.item.exactMatch
                ? this._fuseUtilsService.exactMatchOptions
                : this._fuseUtilsService.subsetMatchOptions;

        // Get the parent navigation component
        this._fuseVerticalNavigationComponent = this._fuseNavigationService.getComponent(this.name);

        // Mark for check
        this._changeDetectorRef.markForCheck();

        // Subscribe to onRefreshed on the navigation component
        this._fuseVerticalNavigationComponent.onRefreshed.pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe(() => {

            // Mark for check
            this._changeDetectorRef.markForCheck();
        });
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void
    {
    }
}
